import React, {Component} from 'react';
import './verified-css.css';
import {Link} from 'react-router-dom';

export default class Verified extends Component {
    render() {
        return (
            <div id="ver-d">
                <div id="ver-d3a">
                    <div id="ver-d1a">
                        <Link to="/verify">
                            <div id="ver-d2a">
                                Verify
                            </div>
                        </Link>
                    </div>
                    <div id="ver-d1c">
                        <Link to="/enter-email">
                            <div id="ver-d2b">
                                Enter Email
                            </div>
                        </Link>
                    </div>
                </div>
                <div id="ver-d1b">
                    <h1>Verified</h1>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/auth/verify/Verified.js